import alt from 'components/Dispatcher';

/**
 * ScorecardQuestionnaireActions are actions related to the in-session store for
 * scorecard questionnaires
 */
class ScorecardQuestionnaireActions {
  constructor() {
    this.generateActions(
      'addAnswer',
      'removeAnswer',
      'submitAnswers',
      'addComment',
      'removeComment',
      'updateComment',
      'addReason',
      'beginEditing',
      'clearState'
    );
  }
}

export default alt.createActions(ScorecardQuestionnaireActions);
